<div class="upsell-product-box-tbyb px-4 mb-8 font-semibold">
  <div class="upsell-product-box-tbyb__container justify-center mx-auto max-w-md w-full">

    <div class='p-4 pt-8 text-center'>
      <p class='playfair text-5xl font-black mb-4' [innerHTML]="productBoxTitle"></p>
      <p class='font-semibold'>Get <span class='font-bold text-bhmd-blue'>{{productPercent}}% OFF</span> your personalized match,<br>before your order ships!</p>
    </div>
    <div class='upsell-product-box-tbyb-bluebox mx-auto text-center border-2 border-bhmd-blue rounded-2xl m-4 relative'>
      <div class="p-8">
        <div class='text-bhmd-blue text-center text-3xl font-bold'>{{ productPercent }}% OFF</div>
        <div class='relative mx-auto max-w-sm'>
          <img class='mx-auto w-auto max-w-72 my-8 max-h-48' src="{{ image }}">
        </div>
        <div class="playfair text-bhmd-darkblue text-3xl mb-2">{{ productName }}</div> 
        <div class='flex gap-2 justify-center items-center'>
          <div class='relative inline-block text-2xl leading-none'><div class='text-gray-300 select-none'>★★★★★</div><div class='absolute inset-0 overflow-hidden w-[95%]'><div class='text-black'>★★★★★</div></div></div>
          <div class="font-normal text-sm">{{reviewCount}} Reviews</div>
        </div>
        <div class='border-2 border-bhmd-blue text-bhmd-blue rounded-full mx-auto max-w-fit px-2 my-4' [innerHTML]="productBoxSubtitle"></div>
        <div class='flex justify-center gap-4'><span class='font-bold'>{{ yourPrice | dynamicCurrency:currency }}</span><span class='line-through text-gray-600 font-normal'>{{ regularPrice | dynamicCurrency:currency }}</span></div>
      </div>
      <div class="bg-bhmd-lightblue rounded-b-2xl border-t-2 border-bhmd-blue text-sm p-4">{{ mbgDays }}-day money back guarantee. <span class="cursor-pointer underline" (click)="openModal()"> Learn More</span></div>
    </div> 
    <div class='p-4 text-center flex justify-between'><span>Total (Including Tax):</span> <span class="text-right font-normal">{{ (yourPrice + currentUpsellTax) | dynamicCurrency:currency }}<br>(free shipping)</span></div>
    <div class='p-4 text-center text-xs font-normal'><p>By clicking on "Claim {{ productPercent }}% off", you will be charged immediately and receive another order confirmation. This amount will be charged in addition to the original order.</p></div>
    <div class="mt-2 flex justify-center gap-2 desktop:gap-8 max-w-xl mx-auto">
      <button  
        data-qa="cta-no" 
        class="upsell-product-box__button-no py-4 px-4 basis-1/2 border border-black rounded-lg leading-tight"
        (click)="nextPage(false)" 
        [innerHTML]="buttonNoText" 
        data-te="cta-no">
      </button>
      <button 
        data-qa="cta-yes" 
        class="upsell-product-box__button-yes py-4 px-4 basis-1/2 rounded-lg bg-bhmd-blue text-white font-bold leading-tight"
        (click)="nextPage(true)" 
        data-te="cta-yes" 
        [innerHTML]="buttonYesText">
      </button>
    </div>

  </div>

  <!-- Modal -->
  <div 
    *ngIf="isModalOpen" 
    class="modal-backdrop fixed inset-0 bg-black bg-opacity-70 px-4 flex justify-center items-center z-[1000] animate-fade-in" 
    (click)="onModalClick($event)"
    (keydown.escape)="closeModal()"
    tabindex="0">
    <div class="modal-content bg-white rounded-xl max-w-2xl  overflow-y-auto relative shadow-2xl animate-slide-in">
      <button 
        class="modal-close-button absolute top-4 right-5 bg-none border-none text-3xl font-bold text-bhmd-blue cursor-pointer p-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-200" 
        (click)="closeModal()"
        aria-label="Close modal">
        ×
      </button>
      <div class="p-6 desktop:p-8 text-xs desktop:text-sm font-normal">
        <img class="mx-auto max-w-48" [src]="mbgBadgeLink">
        <div class="text-gray-600 leading-relaxed">
          <div class='text-lg desktop:text-xl text-bhmd-blue text-center my-4 font-bold'>Our Promise to You</div>
          <p>As doctors, we are dedicated to help you get the EXACT results you're looking for. We are confident that we have formulated the very best skincare products available — but if for any reason you are unsatisfied with your purchase, just return it within {{ mbgDays }} days for a full refund — guaranteed.</p><br>
          <p>If you have any questions or concerns about your order, simply call us at 877-828-5528, or email us at <a class="text-bhmd-blue font-bold" target="_blank" href="mailto:customersupport@beverlyhills-md.com">customersupport&#64;beverlyhills-md.com</a> and our experienced customer support specialists will be happy to help!</p><br>
          <p class='mb-0'>Sincerely, Dr. John Layke and Dr. Payman Danielpour<br>Beverly Hills MD</p>
        </div>
      </div>
    </div>
  </div>
</div>
